{
  "form": {
    "loanAmount": {
      "label": "Tarvittava lainan määrä",
      "error": "Syötä lainan määrä",
      "placeholder": "euroa"
    },
    "maturity": {
      "label": "Laina-aika",
      "error": "Syötä laina-aika",
      "tooltip": "Asuntolainan takaisinmaksuaika on yleensä 20-30 vuotta. Kokeile eri laina-aikoja ja tutki niiden vaikutusta kuukausierään ja velan kokonaiskustannuksiin."
    },
    "interestRate": {
      "label": "Kokonaiskorko",
      "error": "Syötä kokonaiskorko",
      "tooltip": "Lainan esimerkkikorko {{currentInterest}}% on laskettu {{date}} korkotiedoilla. Laske esimerkkilaskelmia eri korkoprosenteilla ja näet  miten korko vaikuttaa kuukausierään ja velan kokonaiskustannuksiin. Lainan korkoprosentti voi nousta tai laskea laina-aikana."
    },
    "repaymentMethod": {
      "label": "Takaisinmaksutapa",
      "tooltip": {
        "annuity": "Tasaerä (annuiteetti) on maksuerä, joka sisältää lainan koron ja lyhennyksen. Koron aleneminen pienentää maksuerää ja koron nousu vastaavasti suurentaa sitä. Laina-aika ei muutu.",
        "fixedAnnuity": "Kiinteä tasaerä maksuerä on kiinteä. Korkotason muutokset vaikuttavat vain laina-aikaan. Maksuerä ei muutu. Jos valitset kiinteän tasaerän, voi laina-ajan pituuteen liittyä rajoitteita.",
        "serial": "Tasalyhenteisen lainan lyhennyksen määrä pysyy samana koko laina-ajan. Maksuerä saadaan lisäämällä korko lyhennyksen määrään. Koron aleneminen ja lainamäärän väheneminen pienentävät maksuerää ja koron nousu suurentaa sitä."
      },
      "options": {
        "annuity": "Tasaerä",
        "fixedAnnuity": "Kiinteä tasaerä",
        "serial": "Tasalyhennys"
      }
    },
    "LoanSecurity": "Lainaturva",
    "calculateRepaymentSecurity": "Laske myös lainan takaisinmaksun turva",
    "securityLevel": {
      "label": "Valitse turvan taso",
      "tooltip": "Valitse kuinka ison osan jäljellä olevasta lainamäärästä vakuutus kattaa.",
      "options": {
        "low": "50%",
        "medium": "100%",
        "high": "110%"
      }
    },
    "numberOfApplicants": {
      "label": "Vakuutettavien henkilöiden määrä",
      "error": "Number of applicants required",
      "options": {
        "single": "Yksi vakuutettava",
        "joint": "Kaksi vakuutettavaa"
      }
    },
    "firstBirth": {
      "label": "Päävakuutetun ikä",
      "error": "Valitse ikä"
    },
    "secondBirth": {
      "label": "Parivakuutetun ikä",
      "error": "Valitse ikä"
    },
    "validation": {
      "maturity": {
        "required": "Syötä laina-aika",
        "limit": "Syötä laina-aika vuosissa ({{min}} – {{max}})"
      },
      "interest": {
        "required": "Syötä kokonaiskorko",
        "limit": "Syötä korkoprosentti ({{min}} – {{max}})"
      }
    },
    "submit": "Laske"
  },
  "results": {
    "heading": "Esimerkkilaskelma lainan kuukausikustannuksista",
    "subHeading": "Lähetä meille lainahakemus, niin saat tietää tarkan summan. Lainan hakeminen ei sido sinua mihinkään",
    "applyForLoanLink": "https://danskebank.fi/lainat/hakemus/",
    "donutChart": {
      "monthlyInstallment": "Kuukausierä",
      "amortization": {
        "label": "Lyhennys",
        "tooltip": "Lyhennykset tarkoittavat lainasi takaisinmaksussa osaa, joka kohdistuu lainan saldon pienentämiseen."
      },
      "interestPayment": {
        "label": "Koron maksu"
      },
      "firstInsurancePremium": {
        "label": "Ensimmäinen vakuutusmaksu"
      },
      "loanAmount": {
        "label": "Lainamäärä"
      },
      "maturity": {
        "label": "Laina-aika",
        "tooltip": {
          "text": "Asuntolainan takaisinmaksuaika on yleensä 20-30 vuotta. Voit tutkia eri takaisinmaksuaikoja, korkoja ja lyhennystapoja kululaskurillamme.",
          "link": "Siirry kululaskuriin"
        }
      },
      "interestRate": {
        "label": "Korko",
        "tooltip": {
          "label": "Lainan korkoprosentti voi nousta tai laskea laina-aikana. Voit tutkia eri laina-aikoja, korkoja ja takaisinmaksutapoja lainalaskurillamme.",
          "link": "Siirry kululaskuriin"
        }
      }
    },
    "footer": {
      "label": "Voit tutkia lisää eri takaisinmaksuaikoja, korkoja ja lyhennystapoja meidän kululaskurillamme.",
      "ctaButton": "Siirry kululaskuriin"
    }
  },
  "help": "auttaa",
  "button": {
    "applyForLoan": "Hae lainaa"
  },
  "moreInformation": {
    "heading": "Lisätietoja",
    "howTo": {
      "label": "Miten me laskemme",
      "paragraph1": "Lainan tiedot on laskettu syötettyjen tietojen perusteella. Tämä ei ole pankin tarjous. Lainan ehdoista sovitaan henkilökohtaisesti.",
      "paragraph2": "Lainan myöntäminen edellyttää aina hyväksyttyä luottopäätöstä. Luottopäätöksen tekemistä varten Danske Bank tarkistaa asiakkaan henkilöluottotiedot Suomen Asiakastieto Oy:stä. Tämän lisäksi luottohakemuksen käsittelemistä varten voimme hakea ja käsitellä tietojasi Positiivisesta luottotietorekisteristä. Lainan korko ja muut ehdot tarkentuvat lainatarjouksessa. Pyydä oma tarjouksesi Danske Bankista."
    },
    "loanPaymentPlan": {
      "label": "Lainan maksuohjelma",
      "text": "{{currentPayment}} € kuukausierällä tämän lainan maksaminen kestää {{length}} kuukautta ja kokonaiskustannuksesi on {{totalAmount}} €. Maksuohjelma on laskettu {{interest}}%:n korolla.",
      "linkText": "Lainan maksuohjelma",
      "modal": {
        "header": "Lainan maksuohjelma",
        "month": "Kuukausi",
        "payment": "Maksu",
        "abbreviation": "Lyhennys",
        "interest": "Korko",
        "capital": "Pääoma"
      }
    },
    "loanSecurityPayment": {
      "label": "Lainaturva",
      "paragraph1": "Lainaturvan vakuutusmaksu on arvio. Vakuutusmaksu yleensä pienenee lainapääoman pienentyessä. Vakuutusmaksun määrään vaikuttavat lainamäärä, turvan taso ja vakuutetun ikä. Vakuutusmaksu nousee vakuutusaikana vakuutetun iän myötä.",
      "paragraph2": "Lainaturva myönnetään hakemusvaiheessa tehtävän terveysselvityksen perusteella.",
      "paragraph3": "Lainaturvan myöntää Mandatum Henkivakuutusosakeyhtiö (Mandatum), joka vastaa vakuutuksesta. Danske Bank toimii Mandatumin asiamiehenä. Finanssivalvonta valvoo vakuutusedustusta."
    }
  },
  "legalText": {
    "paragraph1": "Esimerkki asuntolainasta: Jos asiakas ottaa 170 000 euron asuntolainan, jossa laina-aika olisi 25 vuotta ja lainan viitekorkona käytetään 12 kk euribor-korkoa, lainan kokonaiskorko olisi 4,278 % (Kuluttajansuojalain mukaan laskettu todellinen vuosikorko 4,452 %). Luoton ja muiden luottokustannusten yhteismäärä on 280 765,04 euroa, sis. järjestelypalkkion 1 020 euroa ja automaattisen tiliveloituksen maksun 2,70 euroa/maksuerä. Maksuerien lukumäärä on 300 kpl. Esimerkki laskettu 25.07.2024 korkotiedoilla."
  },
  "tips": {
    "heading": "Etkö ole varma, kuinka paljon asuntolainaa voit saada?",
    "subHeading": "Käytä laskuriamme saadaksesi alustavan arvion mahdollisesta lainamäärästäsi.",
    "button": "Kokeile paljonko voisit saada lainaa",
    "link": "https://danskebank.fi/sinulle/lainat/asuntolaina/kuinka-paljon-asuntolainaa"
  },
  "years": "vuotta"
}
